"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "style"]; //@ts-check
var Icon = function Icon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    atom: "i",
    ui: false
  }, restProps), {}, {
    className: (0, _classLib.mixClass)(className, "icon"),
    style: (0, _objectSpread2["default"])({
      display: "inline-block",
      verticalAlign: "inherit",
      width: 24
    }, style)
  }));
};
var _default = exports["default"] = Icon;
module.exports = exports.default;